<template>
  <div>
    <div class="card-header">
      <form class="box-search" @submit.prevent="submitForm">
        <div class="form-group">
          <DateRangePicker
            placeholder="Thời gian xuất bán"
            class="w-100"
            :ranges="false"
            @update="transformDate()"
            v-model="dateRange"
            :locale-data="localeData"
          >
            <template v-slot:input="picker">
              <label
                v-if="picker.startDate && picker.endDate"
                style="min-width: 13.5em"
                class="text-center font-size-12"
              >
                {{ picker.startDate | formatDate }} -
                {{ picker.endDate | formatDate }}
              </label>
              <label
                v-else
                style="min-width: 13.5em"
                class="font-size-12 time-placeholder"
              >
                Thời gian giao dịch
              </label>
            </template>
          </DateRangePicker>
        </div>

        <div class="form-group">
          <DateRangePicker
            placeholder="Thời gian xuất bán"
            class="w-100"
            :ranges="false"
            @update="transformActivationDate()"
            v-model="activationDateRange"
            :locale-data="localeData"
          >
            <template v-slot:input="picker">
              <label
                v-if="picker.startDate && picker.endDate"
                style="min-width: 13.5em"
                class="text-center font-size-12"
              >
                {{ picker.startDate | formatDate }} -
                {{ picker.endDate | formatDate }}
              </label>
              <label
                v-else
                style="min-width: 13.5em"
                class="font-size-12 time-placeholder"
              >
                Thời gian kích hoạt VA
              </label>
            </template>
          </DateRangePicker>
        </div>
        <div class="form-group">
          <Select2
            v-model="search.agentIds"
            :settings="searchAgent"
          ></Select2>
        </div>

        <div class="form-group">
          <Select2
            v-model="search.inviteCodes"
            :settings="setTingsInviteCode"
            placeholder="Tìm mã cán bộ"
          ></Select2>
        </div>
        <div class="form-group">
          <input
            type="text"
            v-model="search.mcAccountNo"
            class="form-control"
            placeholder="Số TK ngân hàng"
          />
        </div>

        <div class="form-group">
          <input
            type="text"
            v-model="search.vaBankNumber"
            class="form-control"
            placeholder="Nhập mã VA"
          />
        </div>

        <div class="form-group">
          <input
            type="text"
            v-model="search.mcMobile"
            class="form-control"
            placeholder="Nhập SĐT"
          />
        </div>
<div class="form-group">
            <Select2
              placeholder="Đối tác
"
              v-model="search.partnerCode"
              :options="partnerCodeMap"
            >
            </Select2>
          </div>
        <div class="form-group">
          <Select2
            v-model="search.vaStatus"
            :options="optionVaStatus"
            placeholder="Trạng thái"
          ></Select2>
        </div>

        <div class="form-group form-group-action">
          <button
            @click="submitForm"
            class="pt-2 mr-2 btn btn-primary hc-37"
            data-toggle="tooltip"
            data-placement="top"
            title="Lọc"
          >
            <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
          </button>
          <button
            @click="resetFilters"
            type="button"
            class="pt-2 mr-2 btn btn-outline-light hc-37"
            data-toggle="tooltip"
            data-placement="top"
            title="Bỏ lọc"
          >
            <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
          </button>
        </div>
      </form>
    </div>
    <div class="card-body">
      <div class="tab-content" id="nav-tabContent">
        <div class="p-0">
          <b-table
            :busy.sync="loading"
            sticky-header
            hover
            responsive
            :items="tableData"
            :fields="tableFields"
            :fixed="true"
            :bordered="true"
          >
            <template #table-busy>
              <div class="my-2 text-center">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
            <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
            <template #cell(vaBankNumber)="data">
              {{ data.item.vaBankNumber }}
            </template>

            <template #cell(mcMobile)="data">
              {{ data.item.mcMobile }}
            </template>

            <template #cell(mcHolderName)="data">
              {{ data.item.mcHolderName }}
            </template>

            <template #cell(agentName)="data">
              {{ data.item.agentName }}
            </template>

            <template #cell(inviteCode)="data">
              {{ data.item.inviteCode }}
            </template>

            <template #cell(activatedTimeStr)="data">
              {{ data.item.activatedTimeStr }}
            </template>

            <template #cell(statusStr)="data">
             <span class="badge"  :class="data.item.status === 'ACTIVED' ? 'badge-success' : 'badge-danger'">
              {{ data.item.statusStr }}
             </span>
            </template>

            <template #cell(disabledTimeStr)="data">
              {{ data.item.disabledTimeStr }}
            </template>

            <template #cell(totalTransaction)="data">
              {{ formatQuantity(data.item.totalTransaction) }}
            </template>

            <template #cell(totalAmount)="data">
              {{ formatCurrency(data.item.totalAmount) }}
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="pagination.page"
        :total-rows="pagination.total"
        :per-page="pagination.limit"
        @change="onChangePage"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Config from '@/thirdParty/config'
import { ReportService } from '@/services/report.service'
import { CommonService } from '@/services/common.service'

const tableFields = [
  { key: 'index', label: 'STT', class: 'text-center', thStyle: { width: '80px' }, tdStyle: { width: '80px' } },
  { key: 'vaBankNumber', label: 'Mã VA' },
  { key: 'mcMobile', label: 'SĐT Merchant' },
  { key: 'mcHolderName', label: 'Tên chủ TK' },
  { key: 'mcAccountNo', label: 'Số tài khoản NH' },
  { key: 'agentName', label: 'Chi nhánh' },
  { key: 'inviteCode', label: 'Mã cán bộ' },
  { key: 'activatedTimeStr', label: 'Thời điểm kích hoạt' },
  { key: 'statusStr', label: 'Trạng thái VA' },
  { key: 'disabledTimeStr', label: 'Thời gian cập nhật VA' },
  { key: 'totalTransaction', label: 'Số lượng GD' },
  { key: 'totalAmount', label: 'Số tiền GD' }
]

export default {
  name: 'DetailVAReport',
  data () {
    return {
      loading: false,
      tableFields,
      optionEmployees: [{ id: '0', text: 'Tất cả' }],
      optionVaStatus: [
        { id: '0', text: 'Tất cả' },
        { id: 'INACTIVE', text: 'Ngừng hoạt động' },
        { id: 'ACTIVED', text: 'Đang hoạt động' }
      ],
      tableData: [],
      search: {},
      setTingsInviteCode: {
        multiple: true,
        ajax: {
          delay: 500,
          transport: (params, success, failure) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            const keySearch = txtSearch ?? ''
            if (this.tLoadOwner) {
              clearTimeout(this.tLoadOwner)
            }
            this.tLoadOwner = setTimeout(() => {
              CommonService.getListInviteCode({
                keyword: keySearch,
                sortResultList: [
                  {
                    field: 'createdDate',
                    direction: 'DESC'
                  }
                ]
              }) // AI
                .then((res) => {
                  success({
                    results:
                      res.data?.map((item) => {
                        return {
                          id: item?.inviteCode,
                          text: item.inviteCode || ''
                        }
                      }) || []
                  })
                })
                .catch(failure)
            }, 500)
          }
        }
      },
      searchAgent: {
        multiple: true,
        placeholder: 'Tìm kiếm chi nhánh',
        ajax: {
          delay: 500,
          transport: (params, success, failure) => {
            const txtSearch = params.data?.q?.trim() || ''
            if (!txtSearch) {
              return success({
                results: []
              })
            }
            const keySearch = txtSearch ?? ''
            if (this.tLoadOwner) {
              clearTimeout(this.tLoadOwner)
            }
            this.tLoadOwner = setTimeout(() => {
              CommonService.getListAgentBank({
                keyword: keySearch,
                sortResultList: [
                  {
                    field: 'createdDate',
                    direction: 'DESC'
                  }
                ]
              }) // AI
                .then((res) => {
                  success({
                    results:
                      res.data?.map((item) => {
                        return {
                          id: item?.agentId,
                          text: item.name || ''
                        }
                      }) || []
                  })
                })
                .catch(failure)
            }, 500)
          }
        }
      },
      dateRange: {
        startDate: null,
        endDate: null
      },
      activationDateRange: {
        startDate: null,
        endDate: null
      },
      localeData: Config.localeData,
      pagination: {
        total: 0,
        limit: 20,
        page: 1
      },
      partnerCodeMap: []
    }
  },

  async created () {
    this.fetchData()
    this.fetchĐataPartner()
  },

  methods: {
    async fetchĐataPartner () {
      try {
        const data = await CommonService.getListAgentPartner({ page: 1, limit: 1000 })
        if (data.code === 1000) {
          this.partnerCodeMap = data.data.map((item) => {
            return {
              id: item?.code,
              text: item.name || ''
            }
          }) || []
          this.partnerCodeMap.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        this.showFailMx(error.message ?? error)
      }
    },
    resetFilters () {
      this.search = {}
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      this.activationDateRange = {
        startDate: null,
        endDate: null
      }
      this.pagination.page = 1
      this.fetchData()
    },
    onChangePage (page) {
      this.pagination.page = page
      this.fetchData()
    },
    transformDate () {
      if (this.dateRange.startDate && this.dateRange.endDate) {
        this.search.fromTransactionDate = moment(this.dateRange.startDate)
          .startOf('day')
          .valueOf()
        this.search.toTransactionDate = moment(this.dateRange.endDate)
          .endOf('day')
          .valueOf()
      } else {
        delete this.search.fromTransactionDate
        delete this.search.toTransactionDate
      }
    },

    transformActivationDate () {
      if (
        this.activationDateRange.startDate &&
        this.activationDateRange.endDate
      ) {
        this.search.fromActiveDate = moment(this.activationDateRange.startDate)
          .startOf('day')
          .valueOf()
        this.search.toActiveDate = moment(this.activationDateRange.endDate)
          .endOf('day')
          .valueOf()
      } else {
        delete this.search.fromActiveDate
        delete this.search.toActiveDate
      }
    },

    async submitForm (event) {
      event.preventDefault()
      this.pagination.page = 1
      await this.fetchData()
    },

    formatQuantity (value) {
      return value?.toLocaleString('vi-VN')
    },

    formatCurrency (value) {
      return value?.toLocaleString('vi-VN') + ' VNĐ'
    },
    filterObject (obj) {
      const result = {}

      let hasInvalidValue = false

      for (const [key, value] of Object.entries(obj)) {
        if (value === null || value === '0') {
          hasInvalidValue = true
          continue
        }
        result[key] = value
      }

      return hasInvalidValue ? result : obj
    },
    async fetchData () {
      try {
        this.loading = true
        const payload = this.filterObject(this.search)

        const res = await ReportService.getDetailReportVA({
          ...payload,
          page: this.pagination.page,
          limit: this.pagination.limit
          // sortResultList: [
          //   {
          //     field: 'createdDate',
          //     direction: 'DESC'
          //   }
          // ]
        })

        this.$emit('params', {
          ...payload,
          page: this.pagination.page,
          limit: this.pagination.limit
          // sortResultList: [
          //   {
          //     field: 'createdDate',
          //     direction: 'DESC'
          //   }
          // ]
        })
        if (res.code === 1000) {
          this.tableData = res.data || []
          this.pagination.total = res.totalPage.total ?? 0
        } else {
          this.showErr(res.message)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        this.showErr(error.message)
      } finally {
        this.loading = false
      }
    },
    showErr (message) {
      this.notiModal = true
      this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
      this.msgNoti = message
    }
  }
}
</script>

<style scoped>
:deep(.box-search) {
  padding: 0 !important;
}

:deep(.card-body) {
  padding: 10px 0 !important;
}
</style>
